module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-sophia.28346a83.jpeg";